/**
 * Program: Italy
 * Language: Italian
 * Content: Index for all Italian translations
 */

import cookies from '../../common/it/cookies'
import privacy from '../../common/it/privacy'
import terms from './terms'
import { LangProps } from '../../types'

const it: LangProps = {
  /** -------------------------------------------------------------------------- *
   * Document Titles
   * -------------------------------------------------------------------------- */
  document_title_suffix: 'Dyson Trade In con Alchemy',
  document_title_home: 'Inizia',
  document_title_faq: 'Domande frequenti',
  document_title_quiz: 'Quiz',
  document_title_privacy: 'Informativa sulla privacy',
  document_title_terms: 'Termini e condizioni',
  document_title_cookies: 'Politica sui cookie',
  document_title_backoffice: 'Backoffice',
  document_title_signOut: 'Uscita',
  document_title_notFound: 'Pagina non trovata',
  /** -------------------------------------------------------------------------- *
   * Links
   * -------------------------------------------------------------------------- */
  link_home: 'Home',
  link_tradein: 'Trade In',
  link_faq: 'Domande frequenti',
  link_privacy: 'Informativa sulla privacy',
  link_terms: 'Termini & Condizioni',
  link_cookies: 'Gestione dei Cookie',
  link_cookie_preferences: 'Preferenze sui cookie',
  powered_by: 'Offerto da',
  /** -------------------------------------------------------------------------- *
   * Home
   * -------------------------------------------------------------------------- */
  home_hero_title: 'Permuta il tuo vecchio aspirapolvere e risparmia sul tuo nuovo Dyson',
  home_hero_pretitle: 'Dyson Trade In',
  home_hero_intro:
    'Con Dyson Trade In ti rimborseremo fino a € 150 quando acquisti un aspirapolvere Dyson idoneo e lo permuti con quello vecchio.',
  home_hero_cta: 'Inizia la mia permuta',
  home_hero2_title: 'Grazie per essere interessato',
  home_hero2_intro: 'Sfortunatamente il corrente programma di permuta è chiuso',
  home_hero2_outro:
    'Se hai già completato la richiesta di permuta, assicurati che il prodotto da permuta ci sia stato inviato entro 2 settimane. Si prega di fare riferimento alla nostra email per istruzioni.',
  home_hero2_cta: 'Visita il negozio di Dyson',
  home_hero_sponsor: 'Offerto da',
  home_steps_title: '3 semplici passi per effettuare la permuta',
  home_step_1_title: 'Verifica se sei idoneo',
  home_step_1_desc:
    "Possono accedere all'offerta tutti coloro che hanno acquistato i seguenti prodotti:\n\n- un aspirapolvere Dyson Gen5detect™ Absolute o Dyson V15s Detect Submarine™ tra il 22 aprile e il 2 giugno 2024\n\n- un aspirapolvere Dyson V15 Detect™ Absolute tra il 14 maggio e il 2 giugno 2024",
  home_step_2_title: 'Inviaci il tuo vecchio aspirapolvere',
  home_step_2_desc:
    "Ti forniremo un'etichetta di spedizione prepagata gratuita. \n\n Basta imballare il vecchio prodotto, attaccare l'etichetta e consegnarlo al punto di consegna DHL più vicino.",
  home_step_3_title: 'Ricevi il rimborso!',
  home_step_3_desc:
    'Una volta ricevuto il tuo vecchio aspirapolvere, emetteremo il pagamento.\n\nIl pagamento verrà effettuato tra i 30 e i 45 giorni dal ricevimento alla nostra struttura e verrà versato sul conto bancario fornitoci.',
  home_steps_cta: 'Comincia la tua permuta',
  home_faq_title: 'Hai domande?',
  home_faq_button: 'Vedi le nostre domande frequenti',
  home_footer_terms:
    "¹ Su Dyson online, negozi dimostrativi Dyson e partner selezionati. L'importo del cashback dipende dal dispositivo inviato.",
  /** -------------------------------------------------------------------------- *
   * 404
   * -------------------------------------------------------------------------- */
  not_found_title: '404',
  not_found_desc: 'Impossibile trovare la pagina che stai cercando.',
  not_found_button: 'Torna alla homepage',
  /** -------------------------------------------------------------------------- *
   * FAQ
   * -------------------------------------------------------------------------- */
  faq_hero_title: 'Domande frequenti',
  faq_search_placeholder: 'Tipo di ricerca',
  faq_topics_title: 'Ricerca argomenti',
  // -------------------------------------
  // Application Section
  // -------------------------------------
  faq_topic_1_title: 'Applicare',
  faq_topic_1_q1: 'Dove posso fare la richiesta di permuta Dyson?',
  faq_topic_1_a1:
    'Visita [https://www.alchemyglobalsolutions.com/dyson/it](https://www.www.alchemyglobalsolutions.com/dyson/it) per avviare la permuta.',
  faq_topic_1_q2: 'Quali sono i prodotti idonei?',
  faq_topic_1_a2:
    "Possono accedere all'offerta tutti coloro che hanno acquistato i seguenti prodotti:\n\n- un aspirapolvere Dyson Gen5detect™ Absolute  o Dyson V15s Detect Submarine™ tra il 22 aprile e il 2 giugno 2024\n\n- un aspirapolvere Dyson V15 Detect™ Absolute tra il 14 maggio e il 2 giugno 2024 ",
  faq_topic_1_q3: "Quando si svolge l'evento di permuta?",
  faq_topic_1_a3:
    "L'attività è valida per acquisti effettuati su https://www.dyson.it, nei Dyson Demo Store aderenti o presso i rivenditori selezionati in Italia tra il 22 aprile e il 2 giugno compresi e tra il 14 maggio 2024 e il 2 giugno 2024 el Dyson V15 Detect™ Absolute (entrambe le date si considerano incluse)\n\nLe richieste devono essere effettuate tramite il portale di permuta entro 14 giorni dall'acquisto.",
  faq_topic_1_q4: 'Chi sono i rivenditori partecipanti?',
  faq_topic_1_a4: `
  Il sito Dyson: [https://www.dyson.it](https://www.dyson.it)

  I Dyson Demo Store che aderiscono alla promozione sono:

  - Milano - Gae Aulenti
  - Milano - CityLife
  - Torino - Le Gru
  - Roma - Porta di Roma
  - Venezia - Nave De Vero
  - Marcianise - Campania
  - Firenze - I Gigli
  - Bergamo – OrioCenter
  - Palermo - Forum Palermo
  - Carugate – Carosello
  - Verona – Adigeo
  - Bologna - Shopville Gran Reno
  - Napoli - Coin Vomero
  - Roma - Coin Cola di Rienzo.

  Partecipano anche i negozi di Unieuro. Trovi più dettagli su Unieuro.it.`,
  faq_topic_1_q5: "Quali sono i termini dell'offerta permuta?",
  faq_topic_1_a5:
    'Quando acquisti un prodotto Dyson idoneo e lo permuti con un vecchio aspirapolvere, riceverai un pagamento sul conto bancario fornito in fase di registrazione.\n\nPuoi leggere i termini e condizioni completi cliccando la sezione dedicata in fondo alla questa pagina.',
  faq_topic_1_q6: 'Devo vivere in Italia per partecipare a questo programma?',
  faq_topic_1_a6:
    "No, ma devi essere in grado spedirci tramite etichetta prepagata o di portare il dispositivo che desideri permutare presso uno dei punti di consegna designati in Italia ed avere un conto bancario in Italia o in un altro paese SEE per partecipare all'evento di permuta.",
  faq_topic_1_q7: 'Quali dati servono per compilare il modulo?',
  faq_topic_1_a7:
    "Per ricevere il pagamento devi fornirci il tuo nome completo, il numero di serie del nuovo prodotto Dyson acquistato, la ricevuta di acquisto, la marca dell'aspirapolvere permutato, il tuo indirizzo e il tuo IBAN.",
  faq_topic_1_q8: 'Cosa succede se ho perso la ricevuta di acquisto del mio nuovo Dyson?',
  faq_topic_1_a8:
    'Devi richiedere una nuova ricevuta al tuo rivenditore. Senza la ricevuta non possiamo elaborare la tua richiesta di permuta.',
  faq_topic_1_q9: "Chi gestisce l'evento Trade In Dyson?",
  faq_topic_1_a9:
    "L'evento di permuta è gestito per conto di Dyson da [Alchemy](https://www.alchemyglobalsolutions.com), un leader globale nell’economia circolare e nel mercato del trade-in.",
  faq_topic_1_q10: 'Cosa succede dopo aver presentato la richiesta di permuta?',
  faq_topic_1_a10: "Riceverai un'email di conferma con il numero di riferimento.",
  faq_topic_1_q11: "Qual è il tempo necessario per l'elaborazione della mia richiesta di permuta?",
  faq_topic_1_a11:
    "La tua richiesta verrà presa in carico e riceverai la conferma di elaborazione entro 1 giorno lavorativo (lunedì-venerdì).\n\nDopo l'approvazione della tua richiesta ti verrà inviata un'email con un'etichetta di spedizione prepagata che dovrai stampare e incollare sulla scatola del vecchio prodotto da restituire.",
  faq_topic_1_q12:
    "Chi posso contattare se non ho ricevuto un'email di conferma oppure se la mia richiesta non è stata approvata?",
  faq_topic_1_a12:
    'Puoi contattare il team del servizio clienti di Alchemy scrivendo a [dyson@alchemyglobalsolutions.com](mailto:dyson@alchemyglobalsolutions.com).',
  // -------------------------------------
  // Shipping Section
  // -------------------------------------
  faq_topic_2_title: 'Imballaggio e spedizione del tuo vecchio aspirapolvere',
  faq_topic_2_q1: 'Come imballare il mio vecchio aspirapolvere?',
  faq_topic_2_a1:
    "Per inviarci il tuo vecchio prodotto dovrai utilizzare una scatola adatta. Il prodotto deve essere imballato in modo sicuro e senza spazio eccessivo nella scatola. Utilizza una scatola della dimensione giusta.\n\n'Incolla l'etichetta di spedizione prepagata sulla scatola.",
  faq_topic_2_q2: 'Posso utilizzare qualsiasi tipo di scatola?',
  faq_topic_2_a2:
    "Sì, qualsiasi scatola di cartone è adatta. Puoi anche usare la scatola originale dell'aspirapolvere.",
  faq_topic_2_q3: 'Cosa devo mettere nella scatola?',
  faq_topic_2_a3:
    "* Il tuo vecchio aspirapolvere da permutare, integro e funzionante.\n\n* Deve essere un aspirapolvere di dimensioni normali, alimentato con cavo o batteria.\n\n* Assicurati che il contenitore o il sacchetto per la raccolta della polvere sia vuoto.\n\n* Non è necessario inviare tubi, cavi, batterie o altri accessori. Solo l'unità principale (compresa di motore).",
  faq_topic_2_q4: 'Come posso spedire le batterie?',
  faq_topic_2_a4:
    "*  Se il dispositivo è dotato di batteria e desideri inviarla, deve essere integra e priva di danni fisici.\n\n* Non inviarci delle batterie danneggiate.\n\n* Non utilizzare un'etichetta per merci pericolose, la spedizione di una singola batteria non la richiede.",
  faq_topic_2_q5: 'Come posso spedire la scatola?',
  faq_topic_2_a5:
    "* Assicurati che la scatola sia sigillata e sicura, con l'etichetta stampata incollata.\n\n* Consegna il pacco in un centro di consegna DHL o organizza il ritiro dal tuo indirizzo tramite corriere DHL. DHL è l'unico corriere con cui sarà possibile inviare il pacco.",
  // -------------------------------------
  // After Shipping Section
  // -------------------------------------
  faq_topic_3_title: 'Dopo aver permutato il mio prodotto',
  faq_topic_3_q1: 'Come posso sapere se il mio vecchio aspirapolvere è stato ricevuto?',
  faq_topic_3_a1: "Appena ricevuto il tuo prodotto ti invieremo un'email di conferma con l'importo del rimborso.",
  faq_topic_3_q2: "In quanto tempo verrà inviata la conferma di ricezione dell'aspirapolvere?",
  faq_topic_3_a2:
    "Ti confermeremo la ricezione dell'aspirapolvere scambiato via email entro 7 giorni dalla spedizione.",
  faq_topic_3_q3: 'Cosa succede se il mio vecchio aspirapolvere non viene considerato adatto al rimborso?',
  faq_topic_3_a3:
    "Nel caso in cui l'aspirapolvere spedito non corrisponda a quanto dichiarato nella permuta, il nostro servizio clienti ti contatterà immediatamente.",
  faq_topic_3_q4: 'Quanto tempo occorrerà per ricevere il rimborso relativo alla permuta?',
  faq_topic_3_a4:
    "Una volta confermato l'acquisto di un aspirapolvere Dyson idoneo e la ricezione della permuta, il rimborso sarà inviato sul conto bancario indicato entro 30/45 giorni.",
  // -------------------------------------
  // General Section
  // -------------------------------------
  faq_topic_4_title: 'Domande generali',
  faq_topic_4_q1: "Come posso contattare il servizio clienti per l'offerta di permuta?",
  faq_topic_4_a1:
    "Se hai domande sulla permuta o su come compilare la richiesta, puoi contattare il team Alchemy all'indirizzo [dyson@alchemyglobalsolutions.com](mailto:dyson@alchemyglobalsolutions.com).",
  faq_topic_4_q2: 'Quali sono gli orari del servizio clienti?',
  faq_topic_4_a2:
    'Siamo disponibili nei giorni feriali dalle 9:00 alle 17:00, risponderemo a tutte le domande entro un giorno lavorativo al massimo.',
  /** -------------------------------------------------------------------------- *
   * Quiz
   * -------------------------------------------------------------------------- */
  // -------------------------------------
  // Customer Section
  // -------------------------------------
  quiz_s1_title: 'I tuoi dettagli',
  quiz_s1_intro:
    'Ti contatteremo per confermare quando il prodotto scambiato è stato ricevuto e il tuo pagamento sarà elaborato.',
  quiz_s1_q1_label: 'Nome e cognome',
  quiz_s1_q1_placeholder: 'Nome completo',
  quiz_s1_q1_error_required: 'Fornisci il tuo nome completo',
  quiz_s1_q1_error_invalid: 'Per favore inserisci il tuo nome e il tuo cognome',
  quiz_s1_q2_label: 'Indirizzo email',
  quiz_s1_q2_placeholder: 'nome@sito.it',
  quiz_s1_q2_error_required: 'Inserisci il tuo indirizzo email',
  quiz_s1_q2_error_invalid: 'Si prega di inserire un indirizzo email valido',
  quiz_s1_button: 'Continua',
  quiz_s1_button_hint: 'Si prega di completare tutti i campi prima di continuare',
  // -------------------------------------
  // Purchase Section
  // -------------------------------------
  quiz_s2_title: 'Verifica il tuo acquisto recente',
  quiz_s2_short_title: "Verifica l'acquisto",
  quiz_s2_intro:
    "Possiamo accettare una permuta di aspirapolvere solo se hai acquistato un aspirapolvere idoneo da Dyson nei tempi previsti dalla promozione. Assicurati che la data di acquisto, l'oggetto acquistato e il commerciante siano visibili.",
  quiz_s2_next_step: 'Passi successivi: Aspirapolvere Trade In',
  quiz_s2_button: 'Verifica',
  quiz_s2_q1_label: 'Quale modello hai acquistato?',
  // -------------------------------------,
  quiz_s2_serial_help_button: 'Dove lo posso trovare',
  quiz_s2_serial_q1_label: 'Carica la foto di un numero di serie',
  quiz_s2_serial_q1_placeholder: "Carica un'immagine Max 10MB",
  quiz_s2_serial_q2_label: 'Numero di serie',
  quiz_s2_serial_q2_placeholder: '000-00-00000000',
  quiz_s2_serial_q2_error_required: 'Inserisci un numero di serie',
  quiz_s2_serial_q2_error_schema: 'Si prega di inserire un numero di serie valido',
  quiz_s2_serial_q2_error_maxlength: 'Sono consentiti al massimo 15 caratteri',
  // -------------------------------------
  quiz_s2_receipt_q1_label: 'Carica immagine della ricevuta',
  quiz_s2_receipt_q1_placeholder: 'Carica immagine • Max 10MB',
  quiz_s2_receipt_q2_label: 'Data di acquisto',
  quiz_s2_receipt_q2_placeholder: 'GG / MM / AAAA',
  quiz_s2_receipt_q2_error_required: 'Inserisi la data',
  quiz_s2_receipt_q2_error_invalid: 'Deve essere una data valida',
  quiz_s2_receipt_q2_error_length: 'Deve essere una data valida',
  quiz_s2_receipt_q2_error_future: 'La data non può essere futura',
  quiz_s2_receipt_q2_error_range: 'La data deve essere compresa tra il 22/04/2024 e il 02/06/2024',
  quiz_s2_receipt_q3_label: 'Rivenditore',
  quiz_s2_receipt_q3_placeholder: 'Seleziona',
  quiz_s2_receipt_q3_error_required: 'Seleziona il Dyson Punto Vendita',
  // -------------------------------------
  quiz_s2_file_error_required: 'Devi caricare un file',
  quiz_s2_file_error_size: 'File troppo grande',
  quiz_s2_file_error_format: 'Formato file non supportato',
  quiz_s2_file_error_invalid: 'Immagine non valida',
  quiz_s2_file_error_processing: "Errore nell'elaborazione dell'immagine",
  // -------------------------------------
  serial_under_battery_title: 'Sul lato inferiore della batteria',
  serial_under_battery_desc: "Il numero di serie è stampato sul retro della batteria alla base dell'impugnatura.",
  serial_behind_bin_title: 'Dietro il cestino trasparente',
  serial_behind_bin_desc:
    'Guarda sul lato inferiore del contenitore trasparente di fronte al grilletto per rivelare il numero di serie',
  serial_inside_handle_title: "All'interno della maniglia",
  serial_inside_handle_desc:
    "Rimuovi la batteria a scatto per rivelare il numero di serie all'interno dell'impugnatura della macchina.",
  serial_helper_exit_button: 'Chiudi',
  // -------------------------------------
  // Trade-in Section
  // -------------------------------------
  quiz_s3_title: 'Il tuo aspirapolvere da permutare',
  quiz_s3_short_title: 'Valutazione della permuta',
  quiz_s3_intro: 'Parlaci del prodotto che vuoi permutare e ti diremo il suo valore',
  quiz_s3_next_step: 'Passi successivi: Indirizzo di contatto',
  quiz_s3_button: 'Controlla il valore',
  // -------------------------------------
  tradein_q1_label: 'Chi è il produttore?',
  tradein_q1_option_1: 'Dyson',
  tradein_q1_option_2: 'Altro',
  tradein_q2_label: 'Conferma dei termini di permuta Dyson',
  tradein_q2_answer: "Sono d'accordo che la mia permuta soddisfa i",
  tradein_q2_link: 'condizioni del programma',
  tradein_q2_term_1: 'Il mio aspirapolvere è intero e funzionante',
  tradein_q2_term_2: 'Il mio aspirapolvere è un aspirapolvere di dimensione normale alimentato a batteria o con cavo',
  tradein_q2_term_3: 'Il contenitore o Il sacchetto per la raccolta della polvere è vuoto',
  tradein_q2_term_4: 'Sto inviando un aspirapolvere adatto',
  // -------------------------------------
  valuation_title: 'Il valore del tuo aspirapolvere è',
  valuation_desc_1:
    'Ti pagheremo tra 30 e 45 giorni dopo aver ricevuto il tuo prodotto in permuta presso la nostra struttura.',
  valuation_desc_2: 'Le discrepanze tra ciò che descrivi e ciò che riceviamo, potrebbero influenzare la valutazione.',
  valuation_button: 'Continua',
  // -------------------------------------
  // Shipping Section
  // -------------------------------------
  shipping_title: 'Indirizzo',
  shipping_short_title: 'Indirizzo',
  shipping_intro: "Abbiamo bisogno di conoscere il tuo indirizzo per poter generare l'etiquetta di ritiro.",
  shipping_next_step: 'Passi successivi: dettagli di pagamento',
  shipping_button: 'Continua',
  shipping_q1_label: 'Cerca il tuo indirizzo',
  shipping_q1_placeholder: 'Inizia a digitare un indirizzo',
  shipping_address_label: 'Indirizzo della strada',
  shipping_address_placeholder: '',
  shipping_city_label: 'Città',
  shipping_city_placeholder: '',
  shipping_postcode_label: 'Codice postale',
  shipping_postcode_placeholder: '',
  shipping_country_label: 'Paese',
  shipping_country_placeholder: 'Seleziona',
  shipping_no_address_match: 'Non vedi il tuo indirizzo? Aggiungilo manualmente.',
  // -------------------------------------
  // Payment Section
  // -------------------------------------
  payment_title: 'Dettagli di pagamento',
  payment_short_title: 'Dettagli di pagamento',
  payment_intro:
    'Forniscici le coordinate bancarie del conto sul quale desideri che effettuiamo il pagamento. Si prega di controllare attentamente queste informazioni poiché non possiamo essere responsabili per eventuali errori.',
  payment_next_step: 'Passi finali',
  // -------------------------------------
  payment_account_label: 'Titolare del conto',
  payment_account_placeholder: 'Nome completo del titolare del conto',
  payment_account_error_required: 'Inserisi il nome completo del titolare del conto',
  // -------------------------------------
  payment_iban_label: 'IBAN',
  payment_iban_placeholder: 'e.g. IT00 0000 0000 0000 0000 0000 000',
  payment_iban_error_required: 'Inserisi il tuo IBAN',
  // -------------------------------------
  payment_submit_button: 'Invia',
  payment_submit_hint: 'Si prega di completare tutti i campi prima di inviare',
  // -------------------------------------
  payment_terms_text_1: 'Ho letto e accettato i',
  payment_terms_link_1: 'Termini e Condizioni,',
  payment_terms_text_2: 'e',
  payment_terms_link_2: 'politica sulla riservatezza',
  payment_terms_text_3: ' ',
  // -------------------------------------
  confirm_title: 'Conferma i dettagli di pagamento',
  confirm_desc: 'Assicurati che i dettagli di pagamento che hai inserito siano validi.',
  confirm_button: 'Conferma',
  confirm_back_button: 'Torna',

  // -------------------------------------
  // Order Confirmation Section
  // -------------------------------------
  order_title_1: 'Grazie',
  order_title_2: 'la tua permuta è stata creata!',
  order_confirmation_title: 'Quali sono i passaggi successivi?',
  order_confirmation_step1_title: 'Controllo dati inseriti',
  order_confirmation_step1_content:
    'Dobbiamo effettuare alcuni controlli finali sui dettagli che ci hai fornito, ma non preoccuparti, questo è previsto e non dovrebbe richiedere più di 1 giorno lavorativo. Se per qualche motivo abbiamo bisogno di ulteriori informazioni per completare i nostri controlli, ti contatteremo via email',
  order_confirmation_step2_title: 'Imballa il tuo vecchio aspirapolvere da permutare e spediscilo',
  order_confirmation_step2_content:
    "Ti invieremo un'email con la tua etichetta di spedizione gratuita all'indirizzo che hai fornito. Quando la ricevi, imballa il tuo aspirapolvere in permuta in una scatola adatta e attacca la tua etichetta. Le istruzioni per la spedizione saranno incluse nell'email.",
  order_confirmation_step3_title: 'Ricevi il pagamento',
  order_confirmation_step3_contentA:
    'Appena ricevuto il tuo aspirapolvere verrà ispezionato, se è come descritto, effettueremo un pagamento sul conto bancario fornito. Il rimborso verrà effettuato da 30 a 45 giorni dopo la ricezione del prodotto.',
  order_confirmation_step3_contentB:
    'Appena ricevuto il tuo aspirapolvere verrà ispezionato, se è come descritto, effettueremo un pagamento sul conto bancario fornito. Il rimborso verrà effettuato da 30 a 45 giorni dopo la ricezione del prodotto.',
  order_confirmation_step3_contentC: 'Titolare del conto',
  order_confirmation_step3_contentD: 'Il pagamento verrà effettuato da 30 a 45 giorni dopo aver ricevuto il prodotto.',
  /** -------------------------------------------------------------------------- *
   * Errors
   * -------------------------------------------------------------------------- */
  server_error_Z6S:
    "Non è stato possibile creare l'ordine perché il numero di serie è già stato registrato. Si prega di contattare l'assistenza clienti.",
  /** -------------------------------------------------------------------------- *
   * Cookie Consent
   * -------------------------------------------------------------------------- */
  cookie_statement: `Cliccando su 'Accetta tutti i cookie', accetti la memorizzazione dei cookie sul tuo dispositivo per migliorare la navigazione del sito, analizzare l'utilizzo del sito e assistere nelle nostre attività di marketing.`,
  cookie_settings_button: 'Impostazioni dei cookie',
  cookie_accept_all_button: 'Accetta tutti i cookie',
  cookie_allow_selected: 'Accetta i cookie selezionati',
  cookie_allow_all: 'Accetta tutti i cookie',
  cookie_essential_title: 'Essential',
  cookie_essential_desc:
    "Questi cookie sono necessari per il funzionamento del sito web e non possono essere disattivati ​​nei vostri sistemi. In genere, questi cookie vengono impostati solo in risposta alle azioni intraprese dall'utente che corrispondono a una richiesta di servizio, come l'impostazione delle preferenze sulla privacy, l'accesso o la compilazione di moduli. Puoi impostare il tuo browser per bloccare questi cookie o per avvisarti di questi cookie. Tuttavia, alcune aree del sito web non funzioneranno. Questi cookie non memorizzano alcun dato personale.",
  cookie_performance_title: 'Prestazione',
  cookie_performance_desc:
    'Questi cookie ci consentono di contare le visite e le fonti di traffico in modo da poter misurare e migliorare le prestazioni del nostro sito web. Ci aiutano a rispondere a domande su quali pagine sono più popolari, quali sono meno utilizzate e su come i visitatori si muovono nel sito web. Tutte le informazioni raccolte da questi cookie sono aggregate e quindi anonime. Se non consenti questi cookie, non saremo in grado di sapere quando hai visitato il nostro sito web.',
  cookie_functional_title: 'Funzionale',
  cookie_functional_desc:
    'Questi cookie consentono al sito Web di fornire funzionalità e personalizzazione avanzate. Possono essere impostati da noi o da terze parti di cui utilizziamo i servizi sui nostri siti. Se non consenti questi cookie, alcuni o tutti questi servizi potrebbero non funzionare correttamente.',
  cookie_targetting_title: 'Targeting',
  cookie_targetting_desc:
    "Questi cookie possono essere impostati attraverso il nostro sito Web dai nostri partner pubblicitari. Potrebbero essere utilizzati da queste società per creare un profilo dei tuoi interessi e mostrarti annunci pertinenti su altri siti web. Non memorizzano direttamente dati personali, ma si basano sull'identificazione univoca del tuo browser e dispositivo Internet. Se non consenti questi cookie, riceverai pubblicità meno mirata.",
  /** -------------------------------------------------------------------------- *
   * Policy Pages
   * -------------------------------------------------------------------------- */
  terms_body: terms,
  privacy_body: privacy,
  cookies_body: cookies,
}

export default it
